// extracted by mini-css-extract-plugin
export default {"select_border":"CustomSelect_select_border__lWd7w"};